const EducationApi = [
    {
      id: 1,
      category: "education",
      year: "BE, Information Technology (2021 - 2025)",
      title: "Dr. D.Y.Patil College Of Engineering, Pune",
      desc: "Currently pursuing a Bachelor of Engineering in Information Technology at Dr. D.Y. Patil College of Engineering, Pune, with an expected graduation in 2025.",

    },
    {
      id: 2,
      category: "education",
      year: "Science (11th - 12th) (2019 - 2021) ",
      title: "Global Public School & Jr. College, Nashik",
      desc: "Completed 11th and 12th grade with distinction in Science at Global Public School and Jr. College, Nashik, achieving an impressive HSC score of 91.50%.",
    },
    {
      id: 3,
      category: "education",
      year: "1st to 10th (2009 - 2019) ",
      title: "K.N.Kela High School, Nashik",
      desc: "Attended K.N. Kela High School, Nashik, for grades 1 to 10, achieving a strong SSC score of 87.40%.",
    },
    {
      id: 4,
      category: "experience",
      year: "Web Developer (2023 - 2023) ",
      title: "Intern Choice",
      desc: "In my internship project, I successfully developed a dynamic e-commerce platform that enables seamless online shopping experiences for users. Additionally, I also created an engaging meme generator feature, adding a touch of humor and interactivity to the website's content",
      
    },
    {
      id: 5,
      category: "experience",
      year: "Design Team Lead (2022 - Present) ",
      title: "ITESA",
      desc: "Design Team Lead at ITESA (college club). Participated and lead in an annual tech fest event of college.",
    },
  ]
  
  export default EducationApi